module.exports = __webpack_public_path__ + "img/process.e731d439.png";